import type { VehicleAnalyticsData } from '../types';
import type { Event, VdpPageLoad, VDPDataLayerEvent } from '../types/analytics';

type InitialPageLoadTrigger = (vehicleDetails: VehicleAnalyticsData) => void;

// extend window interface so we can add a global
declare global {
  interface Window {
    ixisDataLayer?: VDPDataLayerEvent[];
  }
}
if (typeof window !== 'undefined') {
  window.ixisDataLayer = window.ixisDataLayer || [];
}

export const vdpPageLoad: InitialPageLoadTrigger = (vehicleDetails) => {
  const event: Event<VdpPageLoad> = {
    vdp: {
      type: 'vdp_page_load',
      payload: {
        vehicle: vehicleDetails,
      },
    },
  };

  if (typeof window !== 'undefined') {
    window.ixisDataLayer?.push(event);
  }
};
